import { coerceFlag } from '@/lib/use-clinic-edit-rail-enabled';

/**
 * A default-ON env flag: unset, empty or anything unrecognised is ON; only 'false' / '0' / 'off' (any case,
 * trimmed) turn it off. The opposite of `coerceFlag` (fail-closed), on purpose: Andrew approved the new-message
 * notification ON by default (28 Oct 2026), with this switch as the way to turn it off.
 */
export function defaultOnFlag(value: unknown): boolean {
  if (typeof value !== 'string') return true;
  const normalized = value.trim().toLowerCase();
  return !(normalized === 'false' || normalized === '0' || normalized === 'off');
}

/**
 * The in-app WhatsApp new-message notification: `VITE_INBOX_NOTIFY` (default ON) AND the inbox itself
 * (`VITE_SCHEDULING_AI`, fail-closed), since the toast opens the inbox. Read once per build (Vite inlines both).
 */
export function inboxNotifyEnabled(
  notify: unknown = import.meta.env.VITE_INBOX_NOTIFY,
  inbox: unknown = import.meta.env.VITE_SCHEDULING_AI,
): boolean {
  return coerceFlag(inbox) && defaultOnFlag(notify);
}
